export default __webpack_public_path__ + "static/media/bali.96d050af.png";